/*
 * Copyright (c) 2024 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { JSONable } from '@irian-ro/abstract-resource';
import { ShipmentVoModel } from './shipment-vo.model';

export class ShipmentGroupShortVoModel extends JSONable {

  uuid: string | undefined = undefined;

  shipments: Array<ShipmentVoModel> | undefined = undefined;

  offerRequestUuid: string | undefined = undefined;

  orderUuid: string | undefined = undefined;

}
